import React, { useCallback, useEffect, useState } from 'react'
import { INITIAL_VALUES, mapMembersToMainAndExtra, membersEmptyState, toFormValues } from './form'
import { useErrorHandling } from 'context/errorHandling'
import { SuccessDialog } from 'components/Shared/Dialogs'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { fetchGroup, fetchGroupMembers, updateGroup } from 'services/GroupsService'
import GroupsForm from 'components/Groups/GroupsForm/GroupsForm'
import { Loader } from 'components/Shared/Loader'
import { GROUP_EDIT } from 'context/auth'

export function GroupsEditForm (props) {
  const userGroupId = props.match.params.id

  const [successDialogOpen, setSuccessDialogOpen] = useState(false)
  const [initialValues, setInitialValues] = useState(INITIAL_VALUES)
  const [initialMembers, setInitialMembers] = useState(membersEmptyState)
  const [submitInProgress, setSubmitInProgress] = useState(false)

  const { t } = useTranslation()
  const history = useHistory()
  const { handleError } = useErrorHandling()

  useEffect(() => {
      fetchGroup(userGroupId)
        .then(toFormValues)
        .then(setInitialValues)
        .catch(handleError)
    }, [userGroupId, handleError]
  )

  const fetchMembers = useCallback(() => {
      fetchGroupMembers(userGroupId)
        .then(members => setInitialMembers(mapMembersToMainAndExtra(members)))
        .catch(handleError)
    }, [userGroupId, handleError]
  )

  useEffect(fetchMembers, [fetchMembers])

  const handleSubmit = (updatedGroup, handleGroupMembersChange) => {
    setSubmitInProgress(true)
    Promise.all([
      updateGroup(userGroupId, updatedGroup),
      handleGroupMembersChange(userGroupId)
    ])
      .then(() => setSuccessDialogOpen(true))
      .catch(error => {
        fetchMembers()
        handleError(error)
      })
      .then(() => setSubmitInProgress(false))
  }

  const handleSuccessDialogClose = () => {
    setSuccessDialogOpen(false)
    history.push('/groups')
  }

  return (
    <>
      {submitInProgress && <Loader/>}
      <SuccessDialog
        content="groups.form.edit.onSuccessMessage"
        open={successDialogOpen}
        onClose={handleSuccessDialogClose}
      />
      <GroupsForm
        onSubmit={handleSubmit}
        initialValues={initialValues}
        initialMembers={initialMembers}
        title={t('groups.form.edit.title')}
        requiredPrivileges={[GROUP_EDIT]}
      />
    </>
  )
}
